// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bWyRR","name":"styles_name__3YobG","phone":"styles_phone__E5B5h"};